import changeMobile from './changeMobile'
import changeEmail from './changeEmail'
import changePassword from './changePassword'

export default {
  changeMobile,
  changeEmail,
  changePassword
}
